/**
 * Идёт ли прямо сейчас привязка провайдера через системный браузер - и ответил ли он.
 *
 * Приложение открывало Custom Tab и больше за ним не следило. Если страница не загружалась
 * (а такое видели: окно оставалось полностью чёрным) или человек просто закрывал её, он
 * возвращался в приложение, не видел привязки и не получал ни слова о том, что произошло.
 * Единственное сообщение показывалось, когда окно вообще не удалось открыть.
 *
 * Модулем, а не состоянием React: метку ставит утилита открытия, а читает слушатель браузера в
 * другом дереве. Флаг один - двух привязок одновременно не бывает, окно на экране одно.
 */
let openedProvider: string | null = null;
let answered = false;

/** Окно открыто. Зовётся перед самим открытием: ответ может прийти раньше, чем вернётся промис. */
export const markNativeLinkStarted = (provider: string): void => {
  openedProvider = provider;
  answered = false;
};

/**
 * Провайдер ответил - удачей или отказом, неважно. Ставится на любой разбор возврата, чтобы
 * закрытие окна следом не приняли за молчание.
 */
export const markNativeLinkAnswered = (): void => {
  answered = true;
};

/**
 * Окно закрылось. @returns провайдер, чья привязка осталась без ответа, иначе `null`.
 *
 * Читает и сбрасывает разом: закрытие окна - конец попытки в любом случае.
 */
export const takeUnansweredNativeLink = (): string | null => {
  const provider = answered ? null : openedProvider;
  openedProvider = null;
  answered = false;
  return provider;
};

/** Только для тестов: как при первом запуске. */
export const resetNativeLinkWatchForTests = (): void => {
  openedProvider = null;
  answered = false;
};
